import { render, staticRenderFns } from "./PostalAddressFieldCard.vue?vue&type=template&id=7ebf3e03&"
import script from "./PostalAddressFieldCard.vue?vue&type=script&lang=js&"
export * from "./PostalAddressFieldCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports